import isEmail from "validator/es/lib/isEmail";

import { lazyModule } from "./lazy";

const knownTlds = lazyModule(async () => {
  const { default: tlds } = await import("tlds");
  return new Set(tlds.map((tld) => tld.toLowerCase()));
});

const hasKnownTopLevelDomain = async (email: string): Promise<boolean> => {
  const domain = email.trim().split("@")[1]?.toLowerCase();
  if (!domain) return false;

  const domainParts = domain.split(".");
  const topLevelDomain = domainParts[domainParts.length - 1];
  if (!topLevelDomain) return false;

  const set = await knownTlds();
  return set.has(topLevelDomain);
};

const isValidEmail = (email: string): boolean =>
  isEmail(email.trim(), {
    allow_utf8_local_part: false,
    require_tld: true,
  });

export const isStrictValidEmail = async (email: string): Promise<boolean> =>
  isValidEmail(email) && (await hasKnownTopLevelDomain(email));
